export const SAFE_ZONE_HEIGHT = 122;